import { render, staticRenderFns } from "./RocketAnimation.vue?vue&type=template&id=20c8110a&scoped=true"
import script from "./RocketAnimation.vue?vue&type=script&lang=js"
export * from "./RocketAnimation.vue?vue&type=script&lang=js"
import style0 from "./RocketAnimation.vue?vue&type=style&index=0&id=20c8110a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_97e19ffdeff983ffd98998656a7028c8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8110a",
  null
  
)

export default component.exports